export interface Image {
  title?: string;
  link: string;
  cdnLink?: string;
  alt: string;
  gravity?: ImageGravity;
  randomId?: string;
}

export interface ImageGravity {
  x: number;
  y: number;
  height: number;
  width: number;
}

export interface ImageSize {
  // Mobile : width
  mw?: number;
  // Mobile : height
  mh?: number;
  // Desktop : width
  dw?: number;
  // Desktop : height
  dh?: number;
}

export interface Size {
  width: number;
  height: number;
}

/**
 * Frame a block declares for the server pass, in CSS pixels.
 *
 * `width` is required and `height` optional, on purpose: a height alone describes no frame,
 * since the width would still come from the file's own ratio. The type makes that
 * unwritable rather than leaving it to be caught at runtime.
 */
export interface PregenerationSize {
  width: number;
  height?: number;
}

/**
 * Highest screen density we ask the CDN for. Beyond 2x the extra detail is not
 * visible while the byte count keeps climbing, and phones report up to 4x.
 */
export const MAX_PIXEL_DENSITY = 2;

/**
 * How far the rendered file's ratio may sit from the container's before the client asks the
 * CDN again. Past it, object-cover crops what the CDN did not, and it crops from the centre.
 */
export const MAX_FRAME_RATIO_GAP = 0.02;
